// import { event } from "jquery";
import { indexOf } from "lodash";
import templateUrl from "./employers-directory-main.html";

import "./employers-directory-main.scss"

export const employersDirectoryMainComponent = {
  templateUrl,
  bindings: {
    type: "@",
    title: "@",
    details: "<",
  },
  controller: class employersDirectoryMainComponent {
    constructor($state, toastr, ApiService, EmployersDirectoryService) {
      "ngInject";
      this.$state = $state;
      this.toastr = toastr;
      this.imageUrl = null;
      this.ApiService = ApiService;
      this.EmployersDirectoryService = EmployersDirectoryService;
    }
    $onInit() {
      this.label = "Company Address"
      this.programsArray=[],
      this.selelectedIndustryError = "",
      this.hiringResourceError=""
      this.selelectedCityError="";
      this.zipcodeError="";
      this.AllCities=[];
      this.AllIndustries=[];
      this.getAllCities();
      this.getAllIndustries();
      this.veteranHiringProcess = "",
      this.dodSkillBridges = "",
      this.temUuid = "",
      this.disableSubmitBtn = false;

      if(this.details && this.details.fileUuid) {
        this.imageUrl = this.ApiService.getImageUrl(this.details.fileUuid);
      }
      if(this.type === "Edit") {
           this.details.programs && this.details.programs.map((item) =>{
             this.programsArray.push(item);
             this.details.programs=""
           })
      }
      if(this.type === "Edit" && this.AllCities.length === 0){
        this.AllCities.push(this.details.city)
      }
      if(this.type === "Edit" && this.AllIndustries.length === 0){
        this.AllIndustries.push(this.details.industries)
      }
      if(this.imageUrl !== null) {
        this.temUuid = this.details.fileUuid;
      }
    }

    onImageUpload({ details: { uuid } }) {
        if(this.temUuid !== uuid) {
          console.log(this.temUuid)
           this.EmployersDirectoryService.deleteFileUuid(this.temUuid)
           .then((_) =>{
            this.imageUrl = this.ApiService.getImageUrl(uuid);
            this.details.fileUuid = uuid;
           })
        }
    }

    onRemoveImage() {
          this.imageUrl = null;
          this.details.fileUuid = null;
    }

    getAllCities() {
      return this.EmployersDirectoryService.getAllCities().then((item) =>{
           this.getAllCitiesData = item
      })
     }

     getAllIndustries() {
      return this.EmployersDirectoryService.getAllIndustries().then((item) =>{
            this.getAllIndustriesData = item
      })
     }

    handleClick(value) {
      this.skillBridge = value
    }

    handleAdd(event) {
        event.preventDefault();
       if(this.details.programs) {
        this.programsArray.push(this.details.programs);
       }
       this.details.programs = ""
    }

    handleRemoveProgram(program, index) {
      if(this.programsArray !== ""){
        this.programsArray.map((item,indexItem) =>{
             if(index === indexItem) {
                this.programsArray.splice(index,1)
             }
         })
      }
    }

    handleCityChange(value) {
       if(value) {
        this.AllCities.pop();
        if(this.AllCities.length === 0) {
          this.AllCities.push(value)
        }
        if(this.AllCities.length !== 0) {
          this.selelectedCityError = "";
        }
       }
    }

    handleIndustryChange(value) {
      if(value){
        this.AllIndustries.pop();
        if(this.AllIndustries.length === 0) {
          this.AllIndustries.push(value)
        }
        if(this.AllIndustries.length !== 0){
            this.selelectedIndustryError = ""
        }
      }
    }

    handleVeteranHiring(value) {
      if(value !== ""){
        this.veteranHiringProcess = value
        this.hiringResourceError = ""
      }
    }

    handleDodSkillBridge(value) {
      if(value) {
         this.dodSkillBridges = value
      }
    }

    onAddressChange(details) {
      if(details){
          if(details.zipcode) {
             this.zipcodeError = ""
          }else{

          }
      }
      this.details.companyAddress = details;
    }

    handleErrors() {
      if(this.details.city === null) {
        this.selelectedCityError = "This field is required"
      }
      if(this.details.industries === null) {
        this.selelectedIndustryError = "This field is required"
     }
     if(this.details.veteranHiringProcess === undefined) {
       this.hiringResourceError = "Please select Veteran Hiring Preference"
     }
     if(this.details.companyAddress && !this.details.companyAddress.zipcode) {
        this.zipcodeError = "Zip Code is required please select another address"
     }
    }

    onSubmit(){
      let details = {
         displayName:this.details.displayName,
         city:this.AllCities,
         industries:this.AllIndustries,
         numberOfEmployees:this.details.numberOfEmployees,
         averageSalary:this.details.averageSalary,
         veteranHiringProcess:this.details.veteranHiringProcess,
         dodSkillBridge:this.details.dodSkillBridge,
         link:this.details.link ? this.details.link : null,
         programs: this.programsArray.length === 0 ? null : this.programsArray,
         summary:this.details.summary,
         companyAddress:{
          addressLine1:this.details.companyAddress && this.details.companyAddress.addressLine1,
          cityName: this.details.companyAddress && this.details.companyAddress.cityName,
          lat:this.details.companyAddress && this.details.companyAddress.lat,
          lng:this.details.companyAddress && this.details.companyAddress.lng,
          stateCode:this.details.companyAddress && this.details.companyAddress.stateCode,
          stateName:this.details.companyAddress && this.details.companyAddress.stateName,
          zipcode:this.details.companyAddress && this.details.companyAddress.zipcode
         },
         fileUuid:this.details.fileUuid
      }
      if(this.selelectedCityError === "" && this.selelectedIndustryError === "" && this.hiringResourceError === "" && this.zipcodeError === "") {
        this.disableSubmitBtn = true
         this.EmployersDirectoryService.updateDetails(details, this.details, this.type)
         .then((_) =>{
            if(this.type === 'Edit') {
              this.toastr.success(`Company Updated Succesfully`);
              this.$state.go("directory");
            }else{
              this.toastr.success(`Company Created Succesfully`);
              this.$state.go("directory");
            }
         })
         .catch((error) =>{
            this.disableSubmitBtn = false;
            if(this.type === 'Edit') {
              this.toastr.error(error.data.errors.message);
            }else{
              this.toastr.error(error.data.errors.message);
           }
         })
      }
    }
  },
};


// WEBPACK FOOTER //
// ./src/app/components/employers-directory/employers-directory-main/employers-directory-main.component.js